import React from 'react';
import { FaInstagram, FaLinkedin, FaArrowRight, FaQuoteLeft } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import './About.css';
import Footer from '../Footer/Footer';
import FadeInOnScroll from '../FadeInOnScroll/FadeInOnScroll';
import hasanPic from '../../assets/hasan.jpg';
import razaPic from '../../assets/raza.jpg';
import haalwa_logo from '../../assets/haalwa_logo.png';

const team = [
  {
    name: 'Hasan',
    role: 'Founder · Product & Design',
    bio: 'Builds the surfaces. UI, AI, and the way it all feels in your hand. Obsessed with how a single tap should feel obvious.',
    img: hasanPic,
    socials: [
      ['linkedin', 'https://www.linkedin.com/in/hasannaseer41/'],
      ['instagram', 'https://www.instagram.com/realhasan_naseer/'],
    ],
  },
  {
    name: 'Raza',
    role: 'Founder · Engineering',
    bio: 'Builds the spine. Backend systems, scale, and the boring infrastructure that makes the surfaces fast.',
    img: razaPic,
    socials: [['linkedin', '#']],
  },
  {
    name: 'Husain',
    role: 'Software Engineer',
    bio: 'Owns data integrity and security across the findhalal platform. The reason every halal claim is verifiable.',
    img: haalwa_logo,
    isLogo: true,
    socials: [
      ['linkedin', 'https://www.linkedin.com/in/husain-naseer-27bb67176/'],
      ['instagram', 'https://www.instagram.com/husain_23_/'],
    ],
  },
];

function About() {
  return (
    <div className="fh-about">
      <section className="fh-about-hero fh-mesh">
        <div className="fh-orb fh-orb-emerald" style={{ width: 500, height: 500, top: -100, left: -120 }} />
        <div className="fh-orb fh-orb-gold" style={{ width: 480, height: 480, bottom: -80, right: -150 }} />

        <div className="fh-container" style={{ position: 'relative', zIndex: 2, textAlign: 'center' }}>
          <FadeInOnScroll>
            <div className="fh-pill fh-pill-emerald" style={{ marginBottom: 22 }}>About findhalal Inc.</div>
          </FadeInOnScroll>
          <FadeInOnScroll>
            <h1 style={{ maxWidth: 880, margin: '0 auto 22px' }}>
              We're building the <br />
              <span className="fh-gradient-text">halal economy's plumbing.</span>
            </h1>
          </FadeInOnScroll>
          <FadeInOnScroll>
            <p style={{ maxWidth: 600, margin: '0 auto 16px', fontSize: '1.15rem' }}>
              The unglamorous tools, marketplaces, and AI systems that take halal business
              from spreadsheets and Facebook groups to first-class software.
            </p>
          </FadeInOnScroll>
        </div>
      </section>

      {/* Story */}
      <section className="section" style={{ background: 'var(--bg-cream)' }}>
        <div className="fh-container fh-about-story">
          <FadeInOnScroll>
            <div className="fh-eyebrow">Our story</div>
            <h2 style={{ marginBottom: 22 }}>It started with a frustrated <span className="fh-gradient-text">"halal near me."</span></h2>
            <p>
              We grew up Muslim in cities where halal options were Googleable but never reliable.
              Outdated lists. Sponsored TikToks. Facebook groups arguing whether a McDonald's
              chicken burger was actually halal. Our community deserved better infrastructure.
            </p>
            <p>
              In 2024, we shipped <strong>halwaa</strong>, an iOS app that turned halal discovery
              into something gamified, verified, and social. It worked. 2K+ active diners. 40% MoM growth.
              A real community.
            </p>
            <p>
              But every restaurant owner we talked to had the same story: "Yelp doesn't get us.
              Toast costs too much. Catering inquiries get lost in DMs." So we expanded.
              <strong> findhalal Inc.</strong> is the parent that holds halwaa, halwaa for business,
              and the AI compliance platform we're shipping next.
            </p>
            <div style={{ marginTop: 24 }}>
              <Link to="/pricing" className="fh-btn fh-btn-primary">
                See how we partner <FaArrowRight />
              </Link>
            </div>
          </FadeInOnScroll>

          <FadeInOnScroll>
            <div className="fh-glass fh-quote-card">
              <FaQuoteLeft style={{ fontSize: '1.6rem', color: 'var(--gold)', marginBottom: 18 }} />
              <p style={{ fontFamily: 'Instrument Serif, serif', fontStyle: 'italic', fontSize: '1.6rem', lineHeight: 1.4, color: 'var(--text-main)' }}>
                "We don't want to be the next big halal app. We want to be the operating
                system every halal business runs on, quietly, in the background."
              </p>
              <div style={{ marginTop: 22, display: 'flex', alignItems: 'center', gap: 12 }}>
                <img src={hasanPic} alt="Hasan" style={{ width: 42, height: 42, borderRadius: '50%', objectFit: 'cover' }} />
                <div>
                  <div style={{ fontWeight: 700, color: 'var(--text-main)', fontSize: '0.95rem' }}>Hasan, Founder</div>
                  <div style={{ fontSize: '0.85rem', color: 'var(--text-muted)' }}>findhalal Inc.</div>
                </div>
              </div>
            </div>
          </FadeInOnScroll>
        </div>
      </section>

      {/* Team */}
      <section className="section" style={{ background: 'var(--bg-main)' }}>
        <div className="fh-container">
          <FadeInOnScroll>
            <div style={{ textAlign: 'center', marginBottom: 56 }}>
              <div className="fh-eyebrow" style={{ justifyContent: 'center' }}>The people</div>
              <h2>A small team. <span className="fh-gradient-text">Long horizons.</span></h2>
            </div>
          </FadeInOnScroll>

          <div className="fh-team-grid">
            {team.map((m, i) => (
              <FadeInOnScroll key={i}>
                <div className="fh-team-card fh-glass">
                  <img
                    src={m.img}
                    alt={m.name}
                    className="fh-team-avatar"
                    style={m.isLogo ? { objectFit: 'contain', background: 'var(--primary-50)' } : {}}
                  />
                  <h3 style={{ fontSize: '1.3rem', marginBottom: 4 }}>{m.name}</h3>
                  <div className="fh-team-role">{m.role}</div>
                  <p>{m.bio}</p>
                  <div className="fh-team-socials">
                    {m.socials.map(([type, url], si) => (
                      <a key={si} href={url} target="_blank" rel="noopener noreferrer" aria-label={type}>
                        {type === 'linkedin' ? <FaLinkedin /> : <FaInstagram />}
                      </a>
                    ))}
                  </div>
                </div>
              </FadeInOnScroll>
            ))}
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="section fh-mesh-gold">
        <div className="fh-container">
          <FadeInOnScroll>
            <div style={{ textAlign: 'center', marginBottom: 56 }}>
              <div className="fh-eyebrow" style={{ justifyContent: 'center' }}>How we work</div>
              <h2>Three things we won't compromise on.</h2>
            </div>
          </FadeInOnScroll>
          <div className="fh-values-grid">
            {[
              ['01', 'Talk to owners first.', 'Every feature starts in someone\'s kitchen, not in a Notion doc. We only ship what restaurant owners actually asked for.'],
              ['02', 'Verifiable, not viral.', 'Halal is a trust commodity. We build for accuracy first, social proof second. No clickbait, no engagement bait.'],
              ['03', 'Long compounding bets.', 'Halal infrastructure is a 30-year build. We\'re comfortable shipping slow if that\'s what makes things last.'],
            ].map(([n, t, d], i) => (
              <FadeInOnScroll key={i}>
                <div className="fh-glass fh-value-card">
                  <div className="fh-value-num">{n}</div>
                  <h4>{t}</h4>
                  <p>{d}</p>
                </div>
              </FadeInOnScroll>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default About;
